import { render, staticRenderFns } from "./PoiOpeningHours.vue?vue&type=template&id=1bffc1b4&"
import script from "./PoiOpeningHours.vue?vue&type=script&lang=js&"
export * from "./PoiOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports